import { render, staticRenderFns } from "./sentence.vue?vue&type=template&id=2bc8cad6&scoped=true&"
import script from "./sentence.vue?vue&type=script&lang=js&"
export * from "./sentence.vue?vue&type=script&lang=js&"
import style0 from "./sentence.vue?vue&type=style&index=0&id=2bc8cad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc8cad6",
  null
  
)

export default component.exports